/* global DEFAULTS LIMITS PREFS */
import 'core-js';
import 'fast-text-encoding'; // MS Edge support
import 'intl-pluralrules';
import choo from 'choo';
import nanotiming from 'nanotiming';
import routes from './routes';
import getCapabilities from './capabilities';
import controller from './controller';
import dragManager from './dragManager';
import pasteManager from './pasteManager';
import storage from './storage';
import metrics from './metrics';
import experiments from './experiments';
import * as Sentry from '@sentry/browser';
import './main.css';
import User from './user';
import { getTranslator } from './locale';
import Archive from './archive';
import { setTranslate, locale, isRTL } from './utils';

if (navigator.doNotTrack !== '1' && window.SENTRY_CONFIG) {
  Sentry.init(window.SENTRY_CONFIG);
}

if (process.env.NODE_ENV === 'production') {
  nanotiming.disabled = true;
}

(async function start() {
  const currentLocale = locale();
  document.documentElement.lang = currentLocale;
  document.documentElement.dir = isRTL(currentLocale) ? 'rtl' : 'ltr';

  const capabilities = await getCapabilities();
  if (
    !capabilities.crypto &&
    window.location.pathname !== '/unsupported/crypto'
  ) {
    return window.location.assign('/unsupported/crypto');
  }
  // 开发构建下勿注册 SW，否则会长期缓存带 hash 的 app.*.js，改 webpack 后仍加载旧包并报错
  if (capabilities.serviceWorker && process.env.NODE_ENV !== 'development') {
    try {
      await navigator.serviceWorker.register('/serviceWorker.js');
      await navigator.serviceWorker.ready;
    } catch (e) {
      // continue but disable streaming downloads
      capabilities.streamDownload = false;
    }
  }

  const translate = await getTranslator(locale());
  setTranslate(translate);
  // eslint-disable-next-line require-atomic-updates
  window.initialState = {
    LIMITS,
    DEFAULTS,
    PREFS,
    archive: new Archive([], DEFAULTS.EXPIRE_SECONDS),
    capabilities,
    translate,
    storage,
    sentry: Sentry,
    user: new User(storage, LIMITS, window.AUTH_CONFIG),
    transfer: null,
    fileInfo: null,
    locale: locale(),
    baseUrl:
      typeof window.BASE_URL === 'string' && window.BASE_URL
        ? window.BASE_URL
        : window.location.origin + '/'
  };

  const app = routes(choo({ hash: true }));
  // eslint-disable-next-line require-atomic-updates
  window.app = app;
  app.use(experiments);
  app.use(metrics);
  app.use(controller);
  app.use(dragManager);
  app.use(pasteManager);
  app.use(leaveConfirmation);
  app.mount('body');
})();

function leaveConfirmation(state, emit) {
  const LeaveModal = require('./ui/leaveModal');

  // Handle browser close/refresh
  window.addEventListener('beforeunload', event => {
    if (state.archive && state.archive.files.length > 0) {
      event.preventDefault();
      event.returnValue = '';
    }
  });

  // Handle in-app leave confirmation logic
  emit.on('openLeaveModal', () => {
    state.modal = LeaveModal;
    emit('render');
  });

  emit.on('confirmLeave', () => {
    state.modal = null;
    state.archive.clear(); // Clear files so we can leave without warning
    emit('render');
    // If there was a pending navigation, we would resume it here
    // For now, this just clears the state to allow safe leaving
  });
}
